/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './formEditorTopbar.css';
import { FORM_STATUS, FORM_PRIVACY } from '../../common/globals';
import Spinner from '../../common/spinner';
import FormDeleteConfirmationModal from './formDeleteConfirmationModal';

class FormEditorTopbar extends PureComponent {
  handleSelectStatus = (ev) => {
    const {
      onPublish,
      onSave
    } = this.props;

    const {
      value
    } = ev.target;

    if (value === FORM_STATUS.LIVE) {
      onPublish();
    }

    if (value === FORM_STATUS.DRAFT) {
      // The parameter indicates if forms needs to be republished after save
      onSave(false);
    }
  };

  handleView = () => {
    const {
      onView,
      isSaving,
      isDeleting
    } = this.props;

    if (isSaving || isDeleting) {
      return;
    }

    onView();
  };

  handleSave = () => {
    const {
      status,
      onSave
    } = this.props;

    const republish = status === FORM_STATUS.LIVE;

    onSave(republish);
  };

  render() {
    const {
      status,
      privacy,
      isSaving,
      isPublishing,
      isDeleting,
      isModified,
      onBackButtonClick,
      onDelete,
      onPrivacyChange,
      teamName
    } = this.props;

    const disableSelect = isSaving || isDeleting || isPublishing;
    const disableSave = isSaving || !isModified || isPublishing;
    const isLoading = isSaving || isPublishing;

    return (
      <div className="row topbar-container">
        <FormDeleteConfirmationModal
          onDelete={onDelete}
        />
        <div className="left-side-container">
          <h1 className="topbar-header">
            <i
              className="glyphicon glyphicon-menu-left"
              role="button"
              aria-hidden="true"
              onClick={onBackButtonClick}
            />
            Edit form
            <a
              className="btn btn-link"
              data-toggle="modal"
              data-target="#deleteFormModal"
            >
              (Archive)
            </a>
          </h1>
        </div>
        <div className="flex text-right">
          {status === FORM_STATUS.LIVE && (
            <button
              type="button"
              className="btn btn-link"
              onClick={this.handleView}
            >
              <i className="glyphicon glyphicon-share" />
              Open form
            </button>
          )}
        </div>
        <div className="select-container" style={{ marginRight: 12 }}>
          <span className="select-label">
            Privacy
          </span>
          <select
            value={privacy}
            onChange={e => onPrivacyChange(e.target.value)}
            disabled={disableSelect}
            className="form-control"
          >
            <option value={FORM_PRIVACY.TEAM}>
              {`Only members of ${teamName}`}
            </option>
            <option value={FORM_PRIVACY.PUBLIC}>
              Public
            </option>
          </select>
        </div>
        <div className="select-container">
          <span className="select-label">
            Status
          </span>
          <select
            value={status}
            onChange={this.handleSelectStatus}
            disabled={disableSelect}
            className="form-control"
          >
            <option value={FORM_STATUS.DRAFT}>
              Draft
            </option>
            <option value={FORM_STATUS.LIVE}>
              Published
            </option>
          </select>
        </div>
        <div className="save-button-container">
          <button
            type="button"
            onClick={this.handleSave}
            disabled={disableSave}
            className="btn btn-success btn-block"
          >
            Save
            <Spinner isLoading={isLoading} />
          </button>
        </div>
      </div>
    );
  }
}

FormEditorTopbar.propTypes = {
  status: PropTypes.oneOf(_.values(FORM_STATUS)).isRequired,
  privacy: PropTypes.oneOf(_.values(FORM_PRIVACY)).isRequired,
  isSaving: PropTypes.bool.isRequired,
  isPublishing: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  isModified: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onPrivacyChange: PropTypes.func.isRequired,
  teamName: PropTypes.string.isRequired
};

export default FormEditorTopbar;
